<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: '404',
})
</script>
<template>
  <el-result
    class="page-container__report backdrop"
    sub-title="请检查您输入的网址是否正确"
  >
    <template #icon>
      <el-image
        style="width: 90px;"
        :src="ErrorImage"
      />
    </template>
    <template #extra>
      <el-button
        v-blur
        size="small"
        @click="() => $router.replace('/')"
      >
        回首页
      </el-button>
    </template>
  </el-result>
</template>

<script setup lang="ts" name="404">
  import ErrorImage from '@/assets/images/error/404.png';
</script>
